import React from "react";
import PropTypes from "prop-types";
import { ColumnDefaultProps, ColumnPropTypes } from "../../../props";

import { v4 as uuidv4 } from "uuid";
import classNames from "classnames";

import Placeholder from "../../../../placeholder";
import Prefix from "./prefix";
import Suffix from "./suffix";

function Td({ column, footer, i, data, loading }) {
  let tdClasses = classNames(
    {
      [`text-${column.text}`]: column.text
    },
    column.className || ""
  );

  function getTextContent() {
    let result = null;

    if (data && data.length) {
      if (footer.sum || footer.plus || footer.minus) {
        let isPlus = !!footer.plus || !!footer.sum;
        result = 0;

        if (
          (isPlus &&
            (typeof footer.sum === "function" ||
              typeof footer.plus === "function")) ||
          (!isPlus && typeof footer.minus === "function")
        ) {
          for (let item of data) {
            try {
              if (isPlus) {
                if (footer.sum) {
                  result += footer.sum({ item });
                } else {
                  result += footer.plus({ item });
                }
              } else {
                result -= footer.minus({ item });
              }
            } catch (err) {
              console.log("error: wrong function", err);
            }
          }
        } else {
          if (column.field) {
            let fields = [];

            if (
              (footer.sum && !Array.isArray(footer.sum)) ||
              (footer.plus && !Array.isArray(footer.plus)) ||
              (!isPlus && !Array.isArray(footer.minus))
            ) {
              fields.push(column.field);
            } else {
              if (isPlus) {
                fields = footer.sum ? footer.sum : footer.plus;
              } else {
                fields = footer.minus;
              }
            }

            for (let item of data) {
              for (let field of fields) {
                if (item.hasOwnProperty(field)) {
                  try {
                    if (item.hasOwnProperty(column.field)) {
                      if (isPlus) {
                        result += item[column.field] * 1;
                      } else {
                        result -= item[column.field] * 1;
                      }
                    }
                  } catch (err) {
                    console.log("error: field is not number", err);
                  }
                } else {
                  console.log("warning: field is not found", field);
                }
              }
            }
          }
        }
      }

      return result;
    } else {
      if (footer.sum || footer.plus || footer.minus) {
        return <Placeholder />;
      }
    }
  }

  function renderText() {
    let result = getTextContent();
    let returnText = null;

    if (footer.render && typeof footer.render === "function") {
      if (loading) {
        returnText = result;
      } else {
        returnText = footer.render({ result });
      }
    } else {
      returnText = result;
    }

    return returnText;
  }

  let contentTdFootPrefix = null;
  let contentTdFootTitle = null;
  let contentTdFootText = renderText();
  let contentTdFootSuffix = null;

  if (footer.prefix) {
    if (typeof footer.prefix === "boolean") {
      contentTdFootPrefix = <Prefix content={column.prefix || ""} />;
    } else {
      contentTdFootPrefix = <Prefix content={footer.prefix || ""} />;
    }
  }

  if (footer.title) {
    if (typeof footer.title === "boolean") {
      contentTdFootTitle = column.title || "";
    } else {
      contentTdFootTitle = footer.title || "";
    }
  }

  if (footer.title) {
    if (typeof footer.title === "boolean") {
      contentTdFootTitle = column.title || "";
    } else {
      contentTdFootTitle = footer.title || "";
    }
  }

  if (contentTdFootText) {
    if (data && data.length) {
      contentTdFootText = (
        <span className="table-content-data-wrapper">{contentTdFootText}</span>
      );
    } else if (!loading) {
      contentTdFootText = null;
    }
  }

  if (footer.suffix) {
    if (typeof footer.suffix === "boolean") {
      contentTdFootSuffix = <Suffix content={column.suffix || ""} />;
    } else {
      contentTdFootSuffix = <Suffix content={footer.suffix || ""} />;
    }
  }

  return (
    <td
      key={column.id || uuidv4()}
      className={tdClasses}
      colSpan={footer.colSpan || null}
      rowSpan={footer.rowSpan || null}
    >
      <span
        className={`table-content-data ${
          !column.title || !column.title.length ? "padding-no-left" : ""
        }`}
      >
        {contentTdFootPrefix}
        {contentTdFootTitle}
        {contentTdFootText}
        {contentTdFootSuffix}
      </span>
    </td>
  );
}

Td.defaultProps = {
  column: ColumnDefaultProps,
  footer: ColumnDefaultProps,
  data: [],
  loading: false
};

Td.propTypes = {
  column: ColumnPropTypes,
  footer: ColumnPropTypes,
  i: PropTypes.number.isRequired,
  data: PropTypes.array,
  loading: PropTypes.bool
};

export default Td;
